function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#1d1d1b;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "alimentos");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M250.69,281.51a8.07,8.07,0,1,1-8.07-8.06A8.07,8.07,0,0,1,250.69,281.51Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M79.26,57.65H89.94a2.72,2.72,0,0,1,2.72,2.72V82.22a2.72,2.72,0,0,1-2.72,2.72H79.26a2.72,2.72,0,0,1-2.72-2.72V60.38A2.73,2.73,0,0,1,79.26,57.65Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M240.62,294.21h0a2.73,2.73,0,0,0-2.73-2.72h-12a2.73,2.73,0,0,0-2.73,2.72h0a2.74,2.74,0,0,0,2.73,2.73h12A2.74,2.74,0,0,0,240.62,294.21Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M227.11,296.12h0a2.73,2.73,0,0,0,0-3.85l-7.51-7.61a2.73,2.73,0,0,0-3.85,0h0a2.73,2.73,0,0,0,0,3.85l7.51,7.61A2.73,2.73,0,0,0,227.11,296.12Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M237.28,338.44h0a2.73,2.73,0,0,1-2.72-2.73V316.14a2.73,2.73,0,0,1,2.72-2.72h0c1.5,0,6.07,1.23,6.07,2.72L240,335.71A2.74,2.74,0,0,1,237.28,338.44Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M247.85,338.44h0a2.74,2.74,0,0,0,2.73-2.73V316.14a2.74,2.74,0,0,0-2.73-2.72h0c-1.5,0-6.07,1.23-6.07,2.72l3.35,19.57A2.73,2.73,0,0,0,247.85,338.44Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M220,291.64c.09.48.14.77.2,1.05.74,3.23,1.54,6.44,2.2,9.7a41.64,41.64,0,0,1,.8,11c0,.33-.23.89-.42.93-1.06.23-1,.95-.86,1.75.1.61.14,1.22.21,1.83.57,5.19,1.14,10.37,1.74,15.55a4.88,4.88,0,0,1-1.11,3.87,3.82,3.82,0,0,1-4,1.39,4,4,0,0,1-3.14-3.38q-1.2-5.29-2.39-10.59c-.48-2.11-1-4.22-1.45-6.28-5,1.42-9.81,2.8-14.65,4.25-.31.1-.62.71-.72,1.13-1.05,4.41-2,8.84-3.11,13.25a4.21,4.21,0,0,1-4.63,3.25,4.09,4.09,0,0,1-3.43-4.4c0-.81.12-1.62.19-2.43.26-2.88.53-5.76.8-8.77a16.57,16.57,0,0,1-2.39.09,36.05,36.05,0,0,1-5.78-.8c-1.78-.49-2-1.21-1.51-3.09.81-3.23,1.56-6.48,2.42-9.7q5-18.42,10-36.82a6.1,6.1,0,0,0,.14-.72l-.24-.14a9.88,9.88,0,0,0-.91,1.34c-1.9,4-3.77,8-5.65,11.95-1.24,2.62-2.45,5.25-3.74,7.84a3,3,0,0,1-3.37,1.82,2.78,2.78,0,0,1-2.42-2.78,7.61,7.61,0,0,1,.61-2.79q3.48-9.24,7.05-18.45c.64-1.63,1-3.4,2.37-4.69,3.19-3,6.27-6.1,9.44-9.12a34.22,34.22,0,0,1,2.92-2.29c.7-.54,1.41-1.06,2.12-1.58l.94-.37a43.19,43.19,0,0,1,4.71.5c3.12.68,6.2,1.56,9.3,2.29a1.74,1.74,0,0,0,1.37-.28c4.34-3.73,8.64-7.5,13-11.26a3.15,3.15,0,0,1,3.86-.51c1.82,1.2,2,3.53.28,5.34-2.75,3-5.54,5.87-8.32,8.8-1.71,1.8-3.45,3.55-5.12,5.39a4.5,4.5,0,0,1-4.56,1.63c-.52-.11-1.06-.12-1.91-.21.42,1.53.72,2.89,1.18,4.18s1.22,2.67,1.73,4.05c1.88,5,3.7,10.08,5.58,15.1Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.57,252.32l.75-.3a24,24,0,0,0,2.65-2.16,9.61,9.61,0,0,0,2.32-9.67,8.38,8.38,0,0,0-7.82-6.34A8.73,8.73,0,0,0,185.9,239a9.34,9.34,0,0,0,.33,9.8,8,8,0,0,0,7.75,4C194.85,252.7,195.71,252.47,196.57,252.32Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.16,244.16a15.56,15.56,0,0,1,4.34-10,5.17,5.17,0,0,0-5.64,2.81A5.8,5.8,0,0,0,183.16,244.16Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.09,292.2l2.78,9.87,8.34,7.08-2.69,9.75s-23.08-2.18-26.15-8a8.5,8.5,0,0,1,2.69-8.95c1.07-.94,6.92-2.85,6.92-2.85S174.23,285.61,176.09,292.2Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M244.44,294.21h0a2.73,2.73,0,0,1,2.73-2.72h12.05a2.72,2.72,0,0,1,2.72,2.72h0a2.73,2.73,0,0,1-2.72,2.73H247.17A2.74,2.74,0,0,1,244.44,294.21Z",
  transform: "translate(-158.02 -233.84)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M261.4,295.85h0a2.73,2.73,0,0,1-3.81.55L249,290a2.72,2.72,0,0,1-.54-3.81h0a2.72,2.72,0,0,1,3.81-.55l8.55,6.4A2.74,2.74,0,0,1,261.4,295.85Z",
  transform: "translate(-158.02 -233.84)"
});

var SvgAlimentos = function SvgAlimentos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 103.92 106.54",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : React.createElement("title", null, title), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlimentos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alimentos.839795a2.svg";
export { ForwardRef as ReactComponent };